const mainContainer = document.getElementById("prov-map-main-container");
const rfs = document.querySelectorAll('.rf');
const regionsText = document.querySelectorAll('.rt:not(.region)');
const regions = document.querySelectorAll('.region');

const searchContainer = document.getElementById('search-container');
const searchRegions = document.getElementById('search-regions');
const searchResults = document.getElementById('search-results');





const mapContainer = document.querySelector('#map-container');

function addProvCounts() {
  mapContainer.querySelectorAll(".prov-count").forEach(el => el.remove());

  const provCountContainer = document.createElement("div");
  provCountContainer.classList.add("prov-count-container");

  rfs.forEach((rf, index) => {
    const id = rf.id;
    const provenance = id.replace(/^rf/, "");
    const provKey = `UK${provenance}`;
    const count = window.PROV_MAP?.[provKey];
    if (count === undefined) {
      return;
    }

    const countSpan = document.createElement("span");
    countSpan.className = "prov-count";
    countSpan.id = `cs${provenance}`;
    countSpan.textContent = count;

    provCountContainer.appendChild(countSpan);
    mapContainer.appendChild(provCountContainer);

    // highlight map elements
    // document.querySelector(`#li${provenance}`)?.classList.add('hover-force');
    // document.querySelector(`#rt${provenance}`)?.classList.add('hover-force');
    // document.querySelector(`#rf${provenance}`)?.classList.add('hover-force');
  });
}

function moveProvCounts() {
  return
  rfs.forEach((rf) => {
    const id = rf.id;
    const provenance = id.replace(/^rf/, "");
    const countSpan = document.getElementById(`cs${provenance}`);
    if (!countSpan) return;
    const targetRect = rf.getBoundingClientRect();
    const parentRect = mapContainer.getBoundingClientRect();

    const centerX = targetRect.left - parentRect.left + targetRect.width / 2;
    const centerY = targetRect.top - parentRect.top + targetRect.height / 2;
    console.log(`[COUNT POSITION] ${id}`, {
      targetRectLeft: targetRect.left,
      targetRectTop: targetRect.top,
      targetRectWidth: targetRect.width,
      targetRectHeight: targetRect.height,
      targetRectRight: targetRect.right,
      targetRectBottom: targetRect.bottom,
      parentRectLeft: parentRect.left,
      parentRectTop: parentRect.top,
      centerX,
      centerY
    });
    countSpan.style.left = `${centerX}px`;
    countSpan.style.top = `${centerY}px`;
    // countSpan.style.width =  `${targetRect.width}px`;
    // countSpan.style.height =  `${targetRect.height}px`;
    // optional offset tweaks
  });
}


let resizeTimer;

// function resizeFunction() {
//   clearTimeout(resizeTimer);

//   resizeTimer = setTimeout(() => {
//     console.log("resize function triggered");

//     moveProvCounts();

//     const ratio = window.innerHeight / window.innerWidth;
//     document.documentElement.classList.toggle('map-ratio', ratio >= 1.6);
//   }, 100);
// }

// window.addEventListener('resize', resizeFunction);












rfs.forEach(rf => {
  const id = rf.id;
  const provenance = id.replace(/\D+/g, "");
  const firstDigit = provenance[0];

  rf.addEventListener('mouseover', () => {
    console.log("rf mouseover triggered");
    if (!rf.style.opacity) {
      document.getElementById(`li${provenance}`)?.classList.add('hover');
      document.getElementById(`rt${provenance}`)?.classList.add('hover');
      rf.classList.add('hover');
    }
  });

  rf.addEventListener('mouseout', () => {
    console.log("rf mouseout triggered");
    document.getElementById(`li${provenance}`)?.classList.remove('hover');
    document.getElementById(`rt${provenance}`)?.classList.remove('hover');
    rf.classList.remove('hover');
    // rf.style.removeProperty("opacity");
  });
});




regionsText.forEach(regText => {
  const id = regText.id;
  const provenance = id.replace(/\D+/g, "");
  const firstDigit = provenance[0];
  regText.addEventListener('mouseover', () => {
    if (!regText.style.opacity) {
      document.getElementById(`li${provenance}`)?.classList.add('hover');
      document.getElementById(`rf${provenance}`)?.classList.add('hover');
      regText.classList.add('hover');
    }
  });
  regText.addEventListener('mouseout', () => {
    if (!document.getElementById(`rs${firstDigit}`) && !document.getElementById(`rs${provenance}`)) {
      document.getElementById(`li${provenance}`)?.classList.remove('hover');
      document.getElementById(`rf${provenance}`)?.classList.remove('hover');
      regText.classList.remove('hover');
      if (!document.getElementById(`rs${provenance}`)) {
        regText.style.removeProperty("opacity");
      }
    }
  });
});



regions.forEach(region => {
  const id = region.id;
  const regionId = id.replace(/\D+/g, "");


  const addHover = () => {
    //console.log(regionId, "hovered");
    document.querySelectorAll(`[id^="li${regionId}"]`)
      .forEach(el => el.classList.add('hover'));
    document.querySelectorAll(`[id^="rt${regionId}"]`)
      .forEach(el => el.classList.add('hover'));
    document.querySelectorAll(`[id^="rf${regionId}"]`)
      .forEach(el => el.classList.add('hover'));
  };

  const removeHover = () => {
    //console.log(regionId, "unhovered");
    let isRS = false;
    if (document.getElementById(`rs${regionId}`)) {
      isRS = true;
    }
    
    console.log("noRS:", isRS, "rs", regionId);
    document.querySelectorAll(`[id^="li${regionId}"]`).forEach(el => {
      const id = el.id;
      const idNum = id.replace(/\D+/g, "");
      el.classList.remove('hover');
      if (!isRS && !document.getElementById(`rs${idNum}`)) {
        el.style.removeProperty("opacity");
      }
    });
    document.querySelectorAll(`[id^="rt${regionId}"]`).forEach(el => {
      const id = el.id;
      const idNum = id.replace(/\D+/g, "");
      el.classList.remove('hover');
      if (!isRS && !document.getElementById(`rs${idNum}`)) {
        el.style.removeProperty("opacity");
      }
    });
    document.querySelectorAll(`[id^="rf${regionId}"]`).forEach(el => {
      const id = el.id;
      const idNum = id.replace(/\D+/g, "");
      el.classList.remove('hover');
      if (!isRS && !document.getElementById(`rs${idNum}`)) {
        el.style.removeProperty("opacity");
      }
    });
  };
  region.addEventListener('mouseover', addHover);
  region.addEventListener('mouseout', removeHover);





  region.addEventListener('click', () => {
    const existing = document.getElementById(`rs${provenance}`);

    function toggleOpacity() {
      if (region.style.getPropertyValue("opacity") === "1") {
        region.style.removeProperty("opacity");
        document.querySelectorAll('[id^="li' + provenance + '"]')
          .forEach(el => el.style.opacity = "0.25");
        document.querySelectorAll('[id^="rt' + provenance + '"]')
          .forEach(el => el.style.opacity = "0.25");
        document.querySelectorAll('[id^="rf' + provenance + '"]')
          .forEach(el => el.style.opacity = "0.25");
      } else {
        region.style.opacity = "1";
        document.querySelectorAll('[id^="li' + provenance + '"]')
          .forEach(el => el.style.opacity = "1");
        document.querySelectorAll('[id^="rt' + provenance + '"]')
          .forEach(el => el.style.opacity = "1");
        document.querySelectorAll('[id^="rf' + provenance + '"]')
          .forEach(el => el.style.opacity = "1");
      }
    }

    toggleOpacity();

    if (existing) {
      existing.remove();
    } else {
      document.querySelectorAll(`[id^="rs${provenance}"]`)
        .forEach(el => el.remove());
      const p = document.createElement('p');
      p.id = `rs${provenance}`;
      p.textContent = `UK${provenance}0x`;
      p.className = 'rs';

      searchRegions.appendChild(p);
    }
  });
});


















function populateSearchResults() {
  // console.log("populateSearchResults called");
  const rs = document.querySelectorAll('.rs');
  
  if (rs.length !== 0) {
    searchResults.innerHTML = '';
    // console.log("more length than 0");
    rs.forEach(rs => {
      const regionId = rs.id;
      const provenance = regionId.replace(/\D+/g, "");
      const searchQuery = `UK${provenance}`;
      // console.log("region ID:", searchQuery);

      window.productsArray.forEach(product => {
        product.variants.forEach(variant => {
          // Ensure both are strings and compare case-insensitively
          const price = parseFloat(variant.price);
          if (
            variant.title &&
            searchQuery &&
            variant.title.toUpperCase().includes(searchQuery.toUpperCase()) &&
            parseFloat(variant.price) > 0 &&
            variant.available === true
          ) {
            // Check if a div for this product already exists
            let productDiv = document.getElementById(`product-${product.id}`);
            let textSpans;
            if (!productDiv) {
              // Create parent div for product
              productDiv = document.createElement('div');
              productDiv.className = 'search-result';
              productDiv.id = `product-${product.id}`;

              const textDiv = document.createElement('div');
              textDiv.className = 'product-text';

              const textSpanWrapper = document.createElement('div');
              textSpanWrapper.className = 'text-span-wrapper';

              const textSpansGradient = document.createElement('div');
              textSpansGradient.className = 'text-spans-gradient';

              textSpans = document.createElement('div');
              textSpans.className = 'text-spans';

              const header = document.createElement('a');
              header.textContent = product.title;
              header.href = `/products/${product.handle}`;
              header.target = "_blank";

              if (product.images && product.images.length > 0) {
                const imgContainer = document.createElement('a');
                imgContainer.className = 'thumb-container';
                imgContainer.href = `/products/${product.handle}`;
                imgContainer.target = "_blank";
                const img = document.createElement('img');
                const originalSrc = product.images[0].src;;
                const thumbSrc = originalSrc.replace(/(\.jpg|\.png|\.jpeg)/i, "_200x200$1");
                img.src = thumbSrc
                img.alt = product.title;
                img.className = 'product-thumb';
                imgContainer.appendChild(img);
                productDiv.appendChild(imgContainer);
              }

              textSpanWrapper.appendChild(textSpansGradient);
              textSpanWrapper.appendChild(textSpans);
              textDiv.appendChild(header);
              textDiv.appendChild(textSpanWrapper)
              productDiv.appendChild(textDiv);

              searchResults.appendChild(productDiv);
            } else {
              textSpans = productDiv.querySelector('.text-spans');
            }

            // Append variant as span inside product div
            const variantSpan = document.createElement('span');
            variantSpan.className = 'variant-title';
            variantSpan.textContent = variant.title;
            textSpans.appendChild(variantSpan);
          }
        });
      });
    });
    const searchResult = document.querySelectorAll('.search-result');
    // if (searchResult.length === 0) {
    //   console.log("no search results");
    //   const noResults = document.createElement('p');
    //   if (rs.length > 1) {
    //     noResults.textContent = "Sorry, We have no products in stock from the selected provenances";
    //   } else {
    //     noResults.textContent = "Sorry, We have no products in stock from the selected provenance";
    //   }
    //   noResults.classList.add('no-results-p');
    //   searchResults.appendChild(noResults);
    // } else {
    //   const noResults = document.querySelector('no-results-p');
    //   if (noResults) noResults.remove;
    // }
  }
}






const loadProducts = async () => {
  if (window.productsArray) {
    console.log('[Products] Already loaded');
    return window.productsArray;
  }

  if (!productsPromise) {
    console.log('[Products] Starting fetch...');

    productsPromise = fetch(
      '/collections/bareroot-hedging/products.json?limit=250'
    )
      .then(res => {
        if (!res.ok) {
          throw new Error(`Products fetch failed: ${res.status}`);
        }
        return res.json();
      })
      .then(data => {
        window.productsArray = data.products;

        // Build provenance product counts
        window.PROV_MAP = {};

        window.productsArray.forEach(product => {
          const productProvenances = new Set();

          product.variants.forEach(variant => {
            if (
              !variant.title ||
              parseFloat(variant.price) <= 0 ||
              variant.available !== true
            ) {
              return;
            }

            // Find all UK provenance codes in the variant title
            const matches = variant.title.match(/UK\d+/gi);

            if (!matches) return;

            matches.forEach(provenance => {
              productProvenances.add(provenance.toUpperCase());
            });
          });

          // Count the product once for each provenance
          productProvenances.forEach(provenance => {
            PROV_MAP[provenance] = (PROV_MAP[provenance] || 0) + 1;
          });
        });

        console.log(
          '[Products] Loaded:',
          window.productsArray.length,
          'products'
        );

        console.log('[Products] PROV_MAP:', window.PROV_MAP);

        return window.productsArray;
      })
      .catch(error => {
        productsPromise = null;
        console.error('[Products] Failed to load:', error);
        throw error;
      });
  }

  return productsPromise;
};




let productsPromise;

const productsObserver = new IntersectionObserver(
  (entries, observer) => {
    if (entries[0].isIntersecting) {

      console.log(
        '[Products] Search box approaching viewport — loading products'
      );

      loadProducts().then(() => {
        addProvCounts();
        moveProvCounts();
      });

      observer.disconnect();

      console.log('[Products] Observer disconnected');
    }
  },
  {
    rootMargin: '300px'
  }
);

productsObserver.observe(mainContainer);








function updateScale() {
  const root = document.documentElement;
  let scale;

  if (mainContainer.offsetWidth <= 1080) {
    scale = mainContainer.offsetWidth / 1080;
  } else {
    scale = 1;
  }

  root.style.setProperty("--text_scale", scale);
}

updateScale();
window.addEventListener("resize", updateScale);